import { IExportUsersParams } from '@app/models/interfaces';
import Api from '@app/services/api';
import { useExportDownload } from '@app/services/hooks/useExportDownload';

export const useExportUsersQuery = () => {
  return useExportDownload<IExportUsersParams>({
    downloadPrefix: 'users',
    getFilePath: (filename) => `/users/users/exported/${filename}`,
    mutationFn: (params) => Api.users.exportUsers(params),
  });
};
